import React from "react";
import { Link } from "react-router-dom";
import { resourceInfo } from "../data/ResourceData";

const ResourceHover = () => {
  return (
    <div className="bg-white ">
      <div className="flex justify-center items-center gap-10 py-5">
        {resourceInfo.map((item) => (
          <Link
            to={item.link}
            key={item.id}
            className="flex gap-4 justify-start  items-start w-[300px]"
          >
            <div className="flex gap-4 justify-start  items-start">
              <img src={item.icon} alt="" />

              <div>
                <h3 className="font-semibold mt-[-12px]">{item.title}</h3>
                <h3 className="text-sm text-accent">{item.text}</h3>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <p className="bg-[#B4FDD9] text-primary text-lg p-5 text-center ">
        Looking for a new career? Get in touch
      </p>
    </div>
  );
};

export default ResourceHover;
